import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import { post } from '../Services/http';
import { catchError } from './Error.action';

export const QUICK_SEARCH_QUERY = "QUICK_SEARCH_QUERY";
export const QUICK_SEARCH_RECEIVE = "QUICK_SEARCH_RECEIVE";
export const QUICK_SEARCH_ERROR = "QUICK_SEARCH_ERROR";
export const QUICK_SEARCH_ACTIVE = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = "QUICK_SEARCH_SELECT_ITEM";
export const QUICK_SEARCH_LOADING = "QUICK_SEARCH_LOADING";

let abortController;

export const query = q => (dispatch, getState) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    abortController && abortController.abort();
    abortController = new AbortController();
    dispatch(setLoading(true))
    return post('/api/quickSearch', q, abortController)
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => searchError(error))))
        .finally(() => dispatch(setLoading(false)));
};

export const setLoading = loading => ({
    type: QUICK_SEARCH_LOADING,
    payload: {
        loading,
    }
});

export const setSearchQuery = query => ({
    type: QUICK_SEARCH_QUERY,
    payload: {
        query,
    }
});

export const searchError = error => ({
    type: QUICK_SEARCH_ERROR,
    payload: {
        error,
    }
});

export const receive = data => ({
    type: QUICK_SEARCH_RECEIVE,
    payload: {
        result: data.results,
        products: data.products,
        showAll: data.showAll,
        noHit: data.noHit,
        completionSuggestions: data.completionSuggestions,
        nameSuggestions: data.nameSuggestions
    }
})

export const toggleQuickSearchActive = () => (dispatch, getState) => {
    dispatch(setActive(!getState().quickSearch.active));
};

export const setQuickSearchActive = () => (dispatch, getState) => {
    dispatch(setActive(true));
};

const setActive = visible => ({
    type: QUICK_SEARCH_ACTIVE,
    payload: {
        active: visible,
    }
});

export const handleKeyDown = (event, opt) => (dispatch, getState) => {
    const { result } = getState().quickSearch;

    if (!result || !result.length) {
        return;
    }
    switch (event.keyCode) {
        case 13:
            location.href = opt.searchUrl;
            break;
        default:
            break;
    }
};